import { AfterViewInit, ChangeDetectorRef, Component, Injectable, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/services/user.service';
import { DeviceService } from 'src/app/services/device.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { Error429Service } from 'src/app/services/error429.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UserDataService } from 'src/app/services/user-data.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-alarmas',
  templateUrl: './alarmas.component.html',
  styleUrls: ['./alarmas.component.css']
})
export class AlarmasComponent{

  devicesAndEstablishmentInfo: any[] = []; //Información completa de los dispositivos y establecimientos
  devicesReferences: string = ""; //String con los dispositivos de los que necesitamos información
  nAlarmas: number = 0; //Número de dispositivos que el usuario puede visualizar
  pageSizeOptions: number[] = [15, 30, this.nAlarmas];
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['dev_reference', 'dev_label','est_name','f_inicio','type', 'alarm_range'];
  dataSource :any;
  filterValue: string = '';
  alarmas: any = [];
  alarmasData: any = [];
  // modalidad: any[] = [
  //   {value: 0, name: 'Todas'},
  //   {value: 1, name: 'Tanque'},
  //   {value: 2, name: 'Dispositivo'}
  // ];
  modalidad: any[] = [
    {value: 0, name: 'Todas'},
    {value: 1, name: 'Nivel'},
    {value: 2, name: 'Temperatura'},
    {value: 3, name: 'Conexión'},
    {value: 4, name: 'Dispositivo'}
  ];
  selectedModalidad: number =  0;
  userData: any = [];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private establecimientoSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private router: Router, private error429: Error429Service,
  private userDataService: UserDataService, private location: Location){
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    const state = history.state;
    this.establecimientoSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next: resp => {
        console.log(resp);
        for(let x = 0; x < resp.length; x++){
          for(let j = 0; j < resp[x].alarms.length; j++){
            const tankJson = JSON.parse(resp[x].alarms[j].tank);
            let alarmRange = "-";
            if(tankJson){
              const alarmRanges = JSON.parse(tankJson.alarm_ranges);
              if(resp[x].alarms[j].type == "L1" || resp[x].alarms[j].type == "L2" || resp[x].alarms[j].type == "L3" || resp[x].alarms[j].type == "L4"){
                alarmRange = "Nivel de cerveza mínimo: " + this.soloDosDecimalesConComa(alarmRanges.beerLevelMin) + "%";
              }
              if(resp[x].alarms[j].type == "A1" || resp[x].alarms[j].type == "A2" || resp[x].alarms[j].type == "A3" || resp[x].alarms[j].type == "A4"){
                alarmRange = "Temperatura máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMax) + "ºC";
              }
              if(resp[x].alarms[j].type == "B1" || resp[x].alarms[j].type == "B2" || resp[x].alarms[j].type == "B3" || resp[x].alarms[j].type == "B4"){
                alarmRange = "Temperatura mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerTemperatureMin) + "ºC";
              }
              if(resp[x].alarms[j].type == "C1" || resp[x].alarms[j].type == "C2" || resp[x].alarms[j].type == "C3" || resp[x].alarms[j].type == "C4"){
                if(alarmRanges.beerPressureMax == 1){
                  alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bar";
                } else {
                  alarmRange = "Presión máxima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMax) + " bares";
                }
              }
              if(resp[x].alarms[j].type == "D1" || resp[x].alarms[j].type == "D2" || resp[x].alarms[j].type == "D3" || resp[x].alarms[j].type == "D4"){
                if(alarmRanges.beerPressureMin == 1){
                  alarmRange = "Presión mínima: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bar";
                } else {
                  alarmRange = "Presión mímina: " + this.soloDosDecimalesConComa(alarmRanges.beerPressureMin) + " bares";
                }
              }
            }
            let type = resp[x].alarms[j].desc2;
            this.alarmas.push({
              dev_reference: resp[x].dev_reference,
              dev_label: resp[x].dev_label,
              est_name: resp[x].establishment.est_name,
              f_inicio:  resp[x].alarms[j].started_at,
              type: type ?? "-",
              type_simbol: resp[x].alarms[j].type,
              alarm_range: alarmRange,
              est_id: resp[x].id,
              dev_id: resp[x].alarms[j].device_id,
            })
          }
        }
        console.log(this.alarmas);
      },error: err => {
        console.log(err.error)
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete: () => {
        if (state && state.tipo) {
          this.selectedModalidad = state.tipo
          this.onModalidadChange()
          console.log('Valor recibido:',  state.tipo);
        }else {
          this.dataSource = new MatTableDataSource(this.alarmas);
          //Filtrado personalizado
          this.dataSource.filterPredicate = (data: any, filter: string) => {
            const dataStr = this.displayedColumns
              .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
              .map(key => data[key])
              .join('')
              .toLowerCase();
        
            return dataStr.includes(filter);
          }
        };
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }, 0);
        this.datosRecibidos = true;
      }
    });
    /*const observables = this.userEstablecimientos.map(establecimiento => {
      const alarmaData = new FormData();
      alarmaData.append('establishment_id', establecimiento.id);
      alarmaData.append('start', "2023-01-01");
      alarmaData.append('end', "2023-10-01");
      return this.deviceService.getEstablishmentAlarms(establecimiento.id);
    });*/
    /*Uso del forkJoin para cuando esté complete se hayan terminado todas las subscripciones y 
    se guarden bien los valores en las listas*/
    /*this.forkJoin(observables).subscribe({
      next: responses => {
        console.log(responses);
        for (let i = 0; i < responses.length; i++) {
          const resp = responses[i];
          for (let j = 0; j < resp.devices.length; j++) {
            this.devices.push(resp.devices[j]);
            if (resp.devices[j].alarmas && resp.devices[j].alarmas.length > 0) {
              //this.alarmas.push(...resp.devices[j].alarmas);
              for(let x = 0; x<resp.devices[j].alarmas.length; x++){
                let status;
                if(resp.devices[j].alarmas[x].status == 1){
                  status = "Activa";
                } else {
                  status = "Desactivada";
                }
                let type;
                if(resp.devices[j].alarmas[x].type == "T"){
                  type = "Fallo Tensión Eléctrica";
                } else {
                  if(resp.devices[j].alarmas[x].type == "O"){
                    type = "Fallo Comunicación Dispositivo";
                  } else {
                    type = "No especificada";
                  }
                }
                this.alarmas.push({
                  dev_reference: resp.devices[j].dev_reference,
                  dev_label: resp.devices[j].dev_label,
                  est_name: resp.est_name,
                  f_inicio:  resp.devices[j].alarmas[x].started_at,
                  f_fin: resp.devices[j].alarmas[x].ended_at,
                  status: status,
                  type: type
                });
              }
            }
          }
        }
      },
      error: err => {
        console.log(err.error)
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },
      complete: () => {
        console.log(this.alarmas);
        this.dataSource = new MatTableDataSource(this.alarmas);
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }, 0);
        this.datosRecibidos = true;
      }
    });*/
    //Añadimos el campo dev_reference a la lista de alarmas para que se puedan ordenar con el sort
    /*this.alarmas.forEach((alarma: { dev_reference: any; dev_id: number; }) => {
      alarma.dev_reference = this.devolverdevReference(alarma.dev_id);
    });*/
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
    }
  }

  ngOnDestroy(): void {
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    }
  }

  onModalidadChange() {
    const dispositivoTypes = ["T", "R", "E", "M", "TT", "RR", "EE", "MM"];
    const temperaturTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
    const nivelConsumoTypes = ['L1', 'L2', 'L3', 'L4'];
    const dispositivoDesconectado = ['OO'];
    if(this.selectedModalidad == 0){
      this.dataSource = new MatTableDataSource(this.alarmas);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
          .map(key => data[key])
          .join('')
          .toLowerCase();
    
        return dataStr.includes(filter);
      };
    }
    if(this.selectedModalidad == 1){
      const alarmasTanque = this.alarmas.filter((alarma:any) =>
        nivelConsumoTypes.includes(alarma.type_simbol)
      );
      // Actualiza el dataSource con la nueva lista filtrada
      this.dataSource = new MatTableDataSource(alarmasTanque);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
          .map(key => data[key])
          .join('')
          .toLowerCase();
    
        return dataStr.includes(filter);
      };
    }
    if(this.selectedModalidad == 2){
      const alarmasDispositivo = this.alarmas.filter((alarma:any) =>
        temperaturTypes.includes(alarma.type_simbol)
      );
      this.dataSource = new MatTableDataSource(alarmasDispositivo);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
          .map(key => data[key])
          .join('')
          .toLowerCase();
    
        return dataStr.includes(filter);
      };
      
    }
    if(this.selectedModalidad == 3){
      const alarmasDispositivo = this.alarmas.filter((alarma:any) =>
        dispositivoDesconectado.includes(alarma.type_simbol)
      );
      this.dataSource = new MatTableDataSource(alarmasDispositivo);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
          .map(key => data[key])
          .join('')
          .toLowerCase();
    
        return dataStr.includes(filter);
      };
      
    }
    if(this.selectedModalidad == 4){
      const alarmasDispositivo = this.alarmas.filter((alarma:any) =>
        dispositivoTypes.includes(alarma.type_simbol)
      );
      this.dataSource = new MatTableDataSource(alarmasDispositivo);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = this.displayedColumns
          .filter(key => key !== 'est_id' && key !== 'dev_id' && key !== 'type_simbol')
          .map(key => data[key])
          .join('')
          .toLowerCase();
    
        return dataStr.includes(filter);
      };
      
    }
    console.log("DataSource", this.dataSource)
  }

  descargarExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Ref.Dispositivo', key: 'dev_reference', width: 10 },
      { header: 'Nombre Disp.', key: 'dev_label', width: 10 },
      { header: 'Establecimiento', key: 'est_name', width: 30 },
      { header: 'Fecha Inicio', key: 'f_inicio', width: 30 },
      { header: 'Tipo', key: 'type', width: 30 },
      { header: 'Rango de Alarma', key: 'alarm_range', width: 30 },
    ];
    /*this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });*/
    this.alarmas.forEach((alarma:any) => {
      const formattedAlarma = {
        dev_reference: alarma.dev_reference,
        dev_label: alarma.dev_label,
        est_name: alarma.est_name,
        f_inicio: alarma.f_inicio,
        type: alarma.type,
        alarm_range: alarma.alarm_range
      };
      const row = worksheet.addRow(formattedAlarma);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado alarmas activas DataBeer.xlsx');
    });
  }

  /*
  obtenerDeviceReference(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_reference : "Referencia no encontrada";
  }

  obtenerDeviceLabel(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_label : "Etiqueta no encontrada";
  }*/

  /*devolverdevReference(devId: number){
    for(let i=0; i<this.devices.length; i++){
      if(devId == this.devices[i].id){
        return this.devices[i].dev_reference;
      }
    }
  }*/

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(): void {
    console.log("Valor filtrado:", this.filterValue);
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
  }

}
